export default "__VITE_ASSET__696228d1__"